import { Link, Outlet, useLocation } from "react-router-dom"
import { Button } from "../ui/button"
import { ThemeToggle } from "../ui/theme-toggle"
import { MobileMenu } from "./MobileMenu"

export function MarketingLayout() {
  const { pathname } = useLocation()

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-background/90">
      <header className="h-16 border-b bg-card/50 backdrop-blur-lg fixed w-full z-50">
        <nav className="container mx-auto h-full flex items-center justify-between px-4">
          <Link to="/" className="text-2xl font-bold">
            WithWords
          </Link>

          <div className="hidden md:flex items-center gap-4">
            <Button variant="ghost" asChild>
              <Link to="/features">Features</Link>
            </Button>
            <Button variant="ghost" asChild>
              <Link to="/pricing">Pricing</Link>
            </Button>
            <Button
              variant="ghost"
              asChild
              className={pathname.startsWith('/blog') ? 'bg-accent text-accent-foreground' : ''}
            >
              <Link to="/blog">Blog</Link>
            </Button>
            <Button
              variant="ghost"
              asChild
              className={pathname === '/contact' ? 'bg-accent text-accent-foreground' : ''}
            >
              <Link to="/contact">Contact</Link>
            </Button>

            <ThemeToggle />

            <Button variant="ghost" asChild>
              <Link to="https://app.withwords.app/signin/">Sign In</Link>
            </Button>
            <Button asChild>
              <Link to="https://app.withwords.app/signup/">Get Started</Link>
            </Button>
          </div>

          <div className="md:hidden flex items-center">
            <ThemeToggle />
            <MobileMenu />
          </div>
        </nav>
      </header>

      <main className="pt-16">
        <Outlet />
      </main>

      <footer className="bg-card/50 backdrop-blur-lg py-12 mt-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="font-bold mb-4">WithWords</h3>
              <p className="text-sm text-muted-foreground">
                Master semantic SEO and build topical authority through advanced content frameworks
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-4 text-sm text-muted-foreground">
                <li><Link to="/pricing" className="hover:text-primary block py-3 px-2">Pricing</Link></li>
                <li><Link to="/features" className="hover:text-primary block py-3 px-2">Features</Link></li>
                <li><Link to="/blog" className="hover:text-primary block py-3 px-2">Blog</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-4 text-sm text-muted-foreground">
                <li><Link to="/about" className="hover:text-primary block py-3 px-2">About</Link></li>
                <li><Link to="/contact" className="hover:text-primary block py-3 px-2">Contact</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Legal</h4>
              <ul className="space-y-4 text-sm text-muted-foreground">
                <li><Link to="/privacy-policy" className="hover:text-primary block py-3 px-2">Privacy</Link></li>
                <li><Link to="/terms-and-conditions" className="hover:text-primary block py-3 px-2">Terms</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
